/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Unit } from '@src/app/model/unit';
import { UnitService } from '@src/app/modules/unit/unit.service';
import { FormComboBoxComponent } from '@src/app/shared/form/form-combo-box/form-combo-box.component';
import { CtlHolderComponent } from "@src/app/shared/form/ctl-holder/ctl-holder.component";
import { required } from '@src/app/shared/validators';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-show-unit-billing',
    imports: [MatDialogModule, CtlHolderComponent, MatButtonModule],
    templateUrl: './show-unit-billing.component.html',
    styleUrl: './show-unit-billing.component.scss'
})
export class ShowUnitBillingComponent {
    private unitSvc = inject(UnitService);


    dialogRef = inject(MatDialogRef);
    unitField = FormComboBoxComponent.make('Unit', 'unitId', null,
        {
            items: [],
            optionDisplayValue: u => Unit.getFullName(u),
        }, {
            validators: [required],
        }
    ).setupControl();

    constructor() {
        const unitSvc = this.unitSvc;

        unitSvc.get(true).subscribe(units => {
            this.unitField.setPicklistItems(units);
        })
    }

    addUnit() {
        this.unitSvc.getOne(this.unitField.control.value, null).subscribe( u => {
            this.dialogRef.close(u);
        })
    }

}
